document.addEventListener('DOMContentLoaded', function () { 

  // Slider product img
  
    // if (document.querySelector('.custom-product-slider-swiper-main')) {
    //   const swiperThumbs = new Swiper(".custom-product-slider-swiper-thumbs", {
    //     direction: 'horizontal',
    //     spaceBetween: 11,
    //     slidesPerView: 5,
    //     freeMode: true,
    //     watchSlidesProgress: true,
    //     breakpoints: {
    //       560: {
    //         direction: 'vertical'
    //       }
    //     }
    //   });

    //   const swiperMain = new Swiper(".custom-product-slider-swiper-main", {
    //     spaceBetween: 21,
    //     thumbs: {
    //       swiper: swiperThumbs,
    //     },
    //   });

    //   document.body.addEventListener('change', (event) => {
    //     const input = event.target;
    //     if (!input.matches('.custom-variant-images__item input')) return;

    //     const parentItem = input.closest('.custom-variant-images__item');
    //     const slideIndex = parseInt(parentItem.dataset.slideIndex, 10);
    //     if (!isNaN(slideIndex)) swiperMain.slideTo(slideIndex);
    //   });

    // }

  // Slider product img

  const lockScroll = () => {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  };

  const unlockScroll = () => {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  };

  // Bookmark

    document.addEventListener('click', (e) => {

      // --- OPEN ---
      const bookmarkOpenBtn = e.target.closest('#bookmark-icon');
      if (bookmarkOpenBtn) {
        const bookmarkModal = document.getElementById('bookmark-modal');
        const bookmarkInput = document.getElementById('bookmark-input');

        if (!bookmarkModal || !bookmarkInput) return;

        bookmarkModal.classList.remove('hidden');
        lockScroll();
        bookmarkInput.focus();
        return;
      }

      // --- CLOSE (overlay or close button) ---
      const bookmarkOverlay = e.target.closest('.custom-bookmark-wrapper__input--overlay');
      const bookmarkCloseBtn = e.target.closest('.custom-bookmark-wrapper__input--input-title span:last-child');

      if (bookmarkOverlay || bookmarkCloseBtn) {
        const bookmarkModal = document.getElementById('bookmark-modal');
        if (!bookmarkModal) return;

        bookmarkModal.classList.add('hidden');
        unlockScroll();
        return;
      }

      // --- SAVE ---
      const bookmarkSaveBtn = e.target.closest('#bookmark-save');
      if (bookmarkSaveBtn) {
        e.preventDefault();

        const bookmarkInput = document.getElementById('bookmark-input');
        const bookmarkHiddenInput = document.getElementById('bookmark-hidden');

        if (!bookmarkInput || !bookmarkHiddenInput) return;

        const bookmarkValue = bookmarkInput.value.trim();

        if (bookmarkValue) {
          bookmarkHiddenInput.value = bookmarkValue;
          bookmarkInput.value = '';

          const bookmarkModal = document.getElementById('bookmark-modal');
          if (bookmarkModal) {
            bookmarkModal.classList.add('hidden');
          }

          unlockScroll();
        }

        return;
      }
    });


  // Bookmark

  // OLD Bookmark

    // const bookmarkIcon = document.getElementById('bookmark-icon');
    // const bookmarkModal = document.getElementById('bookmark-modal');
    // const bookmarkOverlay = bookmarkModal.querySelector('.custom-bookmark-wrapper__input--overlay');
    // const bookmarkSaveBtn = document.getElementById('bookmark-save');
    // const bookmarkInput = document.getElementById('bookmark-input');
    // const bookmarkHidden = document.getElementById('bookmark-hidden');
    // const bookmarkCloseBtn = bookmarkModal.querySelector('.custom-bookmark-wrapper__input--input-title span:last-child');
    // const customHeader = document.querySelector('.custom-section-header');
    
    // if (!bookmarkIcon || !bookmarkModal || !bookmarkOverlay || !bookmarkSaveBtn || !bookmarkInput || !bookmarkHidden || !bookmarkCloseBtn) {
    //   return;
    // }

    // const openModal = () => {
    //   bookmarkModal.classList.remove('hidden');
    //   lockScroll();
    //   bookmarkInput.focus();
    // };

    // const closeModal = () => {
    //   bookmarkModal.classList.add('hidden');
    //   unlockScroll()
    // };

    // bookmarkIcon.addEventListener('click', openModal);
    // bookmarkOverlay.addEventListener('click', closeModal);
    // bookmarkCloseBtn.addEventListener('click', closeModal);

    // bookmarkSaveBtn.addEventListener('click', (e) => {
    //   e.preventDefault();
    //   const value = bookmarkInput.value.trim();
    //   if (value) {
    //     bookmarkHidden.value = value;
    //     console.log(bookmarkHidden);
    //     closeModal();
    //     bookmarkInput.value = '';
    //   }
    // });

  // OLD Bookmark

  // Variants form

    document.addEventListener('click', (e) => {
      const wrapper = e.target.closest('.custom-variant-images__item.custom-variant-images__item-form');
      if (!wrapper) return;

      const variantIndex = wrapper.id.replace('variant-images-field-', '');
      const variantModal = document.getElementById(`variant-images-modal-${variantIndex}`);
      if (!variantModal) return;

      const variantOverlay = variantModal.querySelector('.custom-variant-images__item-form-wrapper__input--overlay');
      const variantCloseBtn = variantModal.querySelector('.custom-variant-images__item-form-wrapper__input--close');
      const variantTextarea = variantModal.querySelector(`#variant-images-textarea-${variantIndex}`);
      const variantSaveBtn = variantModal.querySelector(`#variant-images-save-${variantIndex}`);
      if (!variantOverlay || !variantCloseBtn || !variantTextarea || !variantSaveBtn) return;

      const closeHandler = (e) => {
        e.stopPropagation();
        variantModal.classList.add('hidden');
        unlockScroll();
        variantOverlay.removeEventListener('click', closeHandler);
        variantCloseBtn.removeEventListener('click', closeHandler);
        variantTextarea.value = '';
      };

      const variantSaveBtnHandler = (e) => {
        e.preventDefault();
        const value = variantTextarea.value.trim();
        if (value) {
          const hiddenInput = document.getElementById(`custom-variant-${Number(variantIndex) + 1}-hidden`);
          if (hiddenInput) hiddenInput.value = value;
          closeHandler(e);
        }
      };

      variantModal.classList.remove('hidden');
      lockScroll();
      variantTextarea.focus();

      variantOverlay.addEventListener('click', closeHandler);
      variantCloseBtn.addEventListener('click', closeHandler);
      variantSaveBtn.addEventListener('click', variantSaveBtnHandler);
    });


  // Variants form

  // Copy url

    // const popupProduct = document.getElementById('copy-popup');

    // document.addEventListener('click', function(e) {
    //   const copyBtn = e.target.closest('#product-copy-url');
    //   if (!copyBtn) return;

    //   navigator.clipboard.writeText(window.location.href).then(() => {
    //     popupProduct.style.display = 'block';

    //     setTimeout(() => {
    //       popupProduct.style.display = 'none';
    //     }, 1500);
    //   }).catch(err => console.error('Cannot be copied', err));
    // });

    document.addEventListener('click', function(e) {
      const copyBtn = e.target.closest('#product-copy-url');
      if (!copyBtn) return;

      const popupProduct = copyBtn.parentElement.querySelector('[id^="copy-popup-"]');
      if (!popupProduct) return;

      navigator.clipboard.writeText(window.location.href).then(() => {
        popupProduct.style.display = 'block';

        requestAnimationFrame(() => popupProduct.classList.add('is-visible'));

        setTimeout(() => {
          popupProduct.classList.remove('is-visible');

          setTimeout(() => {
            popupProduct.style.display = 'none';
          }, 200);
        }, 1500);
      }).catch(err => console.error('Cannot be copied', err));
    });



  // Copy url

  // modal

    document.querySelectorAll('.custom-variant-images__item-form-wrapper__input').forEach(modal => {
      document.body.appendChild(modal);
    });

    const bookmarkModal = document.getElementById('bookmark-modal');
    if (bookmarkModal) {
      document.body.appendChild(bookmarkModal);
    }

    if (popupProduct) {
      document.body.appendChild(popupProduct);
    }

  // modal

});

